document.addEventListener("DOMContentLoaded", function () {
  const productCards = document.querySelectorAll(".product-card, .featured-card-product");
  const isLoyaltyLogin = (root) => Boolean(root?.querySelector?.("[data-loyalty-login='true']"));

  productCards.forEach((card) => {
    const dataEl = card?.querySelector("[size-variant-data-meta]");
    if (dataEl && !card.dataset.parsed) {
      try {
        card.__parsedProductData = JSON.parse(dataEl.innerHTML);
        card.dataset.parsed = "true";
      } catch (err) {
        console.error("Failed to parse product data", err);
      }
    }
    // Also apply out of stock display on initial load for each card
    const productDataJSON = card.querySelector("[size-variant-data-meta]")?.innerHTML;
    if (productDataJSON) {
      const parsedData = JSON.parse(productDataJSON);
      const default_selected_variant = parsedData.default_selected_variant;
      if (default_selected_variant) {
        updateProductCardDropdownWaitlistDisplay(card, default_selected_variant);
        updateProductCardDropdownOutOfStockDisplay(card, default_selected_variant);
      }
    }
  });

  const updateProductCardDropdownOutOfStockDisplay = (card, variant) => {
    const outOfStockContainer = card.querySelector(".back-in-stock-container");
    const productFormButtons = card.querySelector(".product-form__buttons");

    if (!variant) {
      if (outOfStockContainer) outOfStockContainer.style.display = "none";
      if (productFormButtons) productFormButtons.classList.remove("hide");
      return;
    }
    if (isLoyaltyLogin(card)) {
      return;
    }

    const customMetafields = variant.metafields?.custom;
    const variantOnlineValue = customMetafields?.variantOnline;
    const backInStockValue = customMetafields?.backInStock;
    const enableWaitlistValue =
      customMetafields?.effectiveWaitlist ?? customMetafields?.enableWaitlist;

    // Reset states initially to ensure proper visibility changes
    if (outOfStockContainer) outOfStockContainer.innerHTML = ""; // Clear existing messages
    if (outOfStockContainer) outOfStockContainer.style.display = "none";
    if (productFormButtons) productFormButtons.classList.remove("hide");

    if (variantOnlineValue === "false") {
      if (outOfStockContainer) {
        outOfStockContainer.innerHTML = `
          <button type="button" class="back-in-stock-btn" disabled>
            ${window.variantStrings.unavailable}
          </button>
        `;
        outOfStockContainer.style.display = "block";
      }
      if (productFormButtons) productFormButtons.classList.add("hide");
      return;
    }

    // Check if waitlist should be shown first (takes priority over out-of-stock)
    const isWaitlistEnabled = enableWaitlistValue === true || enableWaitlistValue === "true";
    const shouldShowWaitlist =
      isWaitlistEnabled && (variant.available || (!variant.available && backInStockValue === "true"));

    // If waitlist should be shown, don't show out-of-stock
    if (shouldShowWaitlist) {
      outOfStockContainer.innerHTML = "";
    }

    const shouldShowOutOfStock = !variant.available && backInStockValue === "true" && !isWaitlistEnabled;
    const shouldShowBackInStock = !variant.available && backInStockValue !== "true";
    const parsedData = card.__parsedProductData;
    const productHandle = parsedData?.handle || card.dataset.handle || variant.handle;

    if (shouldShowOutOfStock) {
      if (outOfStockContainer) {
        outOfStockContainer.innerHTML = `
          <button
            type="button"
            class="button button--full-width out-of-stock-btn">
            ${window.getStockStatusLabel?.(productHandle) || window.variantStrings?.soldOut}
          </button>
        `;
        outOfStockContainer.style.display = "block";
      }
      if (productFormButtons) productFormButtons.classList.add("hide");
    } else if (shouldShowBackInStock) {
      if (outOfStockContainer) {
        const root = window.Shopify?.routes?.root || "/";
        const productUrl = `${root}products/${productHandle || ""}`;
        outOfStockContainer.innerHTML = `
          <div class="back-in-stock-form">
            <a href="${productUrl}" class="button button button--full-width button--primary notify-me-btn">Notify Me</a>
          </div>
        `;
        outOfStockContainer.style.display = "block";
      }
      if (productFormButtons) productFormButtons.classList.add("hide");
    } else {
      if (productFormButtons) productFormButtons.classList.remove("hide");
      if (outOfStockContainer) outOfStockContainer.innerHTML = "";
      if (outOfStockContainer) outOfStockContainer.style.display = "none";
    }

    // If waitlist should be shown, make sure buy buttons are hidden
    if (shouldShowWaitlist) {
      productFormButtons.classList.add("hide");
      // Don't touch waitlist container - let updateProductCardDropdownWaitlistDisplay handle it
    }
  };

  const updateProductCardDropdownWaitlistDisplay = (card, variant) => {
    const productFormButtons = card.querySelector(".product-form__buttons");
    const waitlistContainer = card.querySelector(".waitlist-container");

    if (!variant || isLoyaltyLogin(card)) {
      return;
    }

    const customMetafields = variant.metafields?.custom;
    const enableWaitlistValue =
      customMetafields?.effectiveWaitlist ?? customMetafields?.enableWaitlist;
    const backInStockValue = customMetafields?.backInStock;

    // New waitlist logic: 2 cases
    // 1. Variant available AND waitlist = true
    // 2. Not available AND waitlist = true AND back_in_stock_disabled = true
    const isWaitlistEnabled = enableWaitlistValue === true || enableWaitlistValue === "true";
    const shouldShowWaitlist =
      isWaitlistEnabled && (variant.available || (!variant.available && backInStockValue === "true"));

    if (shouldShowWaitlist) {
      // Hide buy buttons when waitlist is enabled
      if (productFormButtons) {
        productFormButtons.classList.add("hide");
      }

      // Show waitlist form
      if (waitlistContainer) {
        waitlistContainer.style.display = "block";
      }
    } else {
      // Show buy buttons when waitlist is disabled
      if (productFormButtons) {
        productFormButtons.classList.remove("hide");
      }

      // Hide waitlist form
      if (waitlistContainer) {
        waitlistContainer.style.display = "none";
      }
    }
  };

  const applyDropdownSwatches = (option, isGetTheLook = false) => {
    const productCardEl = option.closest(".featured-card-product") || option.closest(".product-card");
    if (!productCardEl) return;

    // Ensure product data is parsed for the current card
    if (!productCardEl.__parsedProductData) {
      const productDataJSON = productCardEl.querySelector("[size-variant-data-meta]")?.innerHTML;
      if (!productDataJSON) {
        console.error("Missing product data JSON for card", productCardEl);
        return;
      }
      try {
        productCardEl.__parsedProductData = JSON.parse(productDataJSON);
      } catch (err) {
        console.error("Failed to parse product data in applyDropdownSwatches", err, productDataJSON);
        return;
      }
    }

    const is_bundled = productCardEl.className.includes("bundled-suggested-item");
    let variant;

    if (is_bundled) {
      let selected_option_name;
      if (option.className.includes("mobile-bundle-option")) {
        selected_option_name = Array.from(
          productCardEl.querySelectorAll(".selected-bundle-option.mobile-bundle-option"),
        );
      } else {
        selected_option_name = Array.from(
          productCardEl.querySelectorAll(".selected-bundle-option.desktop-bundle-option"),
        );
      }
      const rawPosition = option.dataset.position;
      const position = parseInt(rawPosition);
      const option_item = option.dataset.value;
      if (!isNaN(position) && selected_option_name[position]) {
        selected_option_name[position].value = option_item;
      }
      const filtered_options = Array.from(selected_option_name)
        .filter((option) => !option.classList.contains("single-product"))
        .map((option) => option.value.trim());

      variant = productCardEl.__parsedProductData.variants.find((inner_variant) => {
        const inner_options = [...inner_variant.options].map((opt) => opt.trim());
        return (
          inner_options.length === filtered_options.length &&
          inner_options.every((option, index) => option === filtered_options[index])
        );
      });
    } else {
      variant = productCardEl.__parsedProductData.variants.find((item) => item.id == option.dataset.id);
    }

    if (!variant) {
      return;
    }

    const {
      id,
      metafields: { custom: { image_url = [], shortDescription = "", size = "", isHudaShade = "" } = {} },
      available,
      price,
      compare_at_price,
      save_price,
    } = variant;

    const selectedProductId = productCardEl?.querySelector(".product-variant-id");
    const primaryImage = productCardEl?.querySelector(".primary_image");
    const addToBagButton = productCardEl?.querySelector(".product-form__submit");
    const shortDescriptionEl = productCardEl?.querySelector(".featured-card_product-description");
    const hudasShadeBadge = productCardEl?.querySelector(".hudas-badge");
    const priceElements = productCardEl?.querySelectorAll(".product-price");
    const compareAtPriceEl = productCardEl?.querySelector(".product-compare-at-price");
    const savePriceEl = productCardEl?.querySelector(".product-save-price");
    const price_sale = productCardEl?.querySelector(".price__sale");
    const price_regular = productCardEl?.querySelector(".price__regular");
    const price_container = productCardEl?.querySelector(".price-section-data");

    if (selectedProductId) selectedProductId.value = id;

    // Remove redundant addToBagButton.toggleAttribute here
    // if (addToBagButton) {
    //   addToBagButton.toggleAttribute("disabled", !available);
    // }

    if (shortDescriptionEl) {
      let desc = shortDescription;
      if (shortDescription && size) desc += ` ● ${size}`;
      shortDescriptionEl.innerHTML = desc;
      shortDescriptionEl.classList.toggle("hide", !shortDescription);
    }

    if (isGetTheLook && hudasShadeBadge) {
      hudasShadeBadge.classList.toggle("hide", isHudaShade !== "HudaShade");
    }

    priceElements.forEach((el) => (el.innerHTML = price));

    if (compare_at_price == price || !Number(compare_at_price.replace(/[^0-9.-]+/g, ""))) {
      price_container.classList.remove("price--on-sale");
      price_sale.style.display = "none";
      price_regular.style.display = "flex";
    } else {
      price_container.classList.add("price--on-sale");
      if (compareAtPriceEl) compareAtPriceEl.innerHTML = compare_at_price;
      if (savePriceEl) savePriceEl.innerHTML = save_price;
      price_regular.style.display = "none";
      price_sale.style.display = "flex";
    }
    if (primaryImage && isGetTheLook) {
      const imageSource = image_url[0];
      const imageSrc = imageSource?.preview_image?.src || imageSource;
      if (primaryImage.src !== imageSrc) {
        if ("requestIdleCallback" in window) {
          requestIdleCallback(() => {
            primaryImage.src = imageSrc;
          });
        } else {
          primaryImage.src = imageSrc;
        }
      }
    }

    if (primaryImage && image_url[0]) {
      const originalUrl = image_url[0];

      const url1x = `${originalUrl}&width=630`;
      const url2x = `${originalUrl}&width=1260`;

      const pictureEl = primaryImage.closest("picture");
      // if (!pictureEl) return; // Removed this line to prevent early exit

      const source = pictureEl?.querySelector("source"); // Use optional chaining
      if (source) {
        source.srcset = `${url1x} 1x, ${url2x} 2x`;
      }

      primaryImage.src = url1x;
    }

    updateProductCardDropdownWaitlistDisplay(productCardEl, variant);
    updateProductCardDropdownOutOfStockDisplay(productCardEl, variant);
  };

  // Use event delegation on a broader container to capture clicks on dynamically added .custom-option elements
  document.addEventListener("click", (event) => {
    const option = event.target.closest(".custom-option");
    if (!option) return;

    const isGetTheLook = option.closest(".get-look-section") !== null;
    applyDropdownSwatches(option, isGetTheLook);
  });

  productCards.forEach((card) => {
    const dataEl = card?.querySelector("[size-variant-data-meta]");
    if (dataEl) {
      const productDataJSON = dataEl.innerHTML;
      if (productDataJSON) {
        const parsedData = JSON.parse(productDataJSON);
        const default_selected_variant = parsedData.default_selected_variant;
        if (default_selected_variant) {
          updateProductCardDropdownWaitlistDisplay(card, default_selected_variant);
          updateProductCardDropdownOutOfStockDisplay(card, default_selected_variant);
        }
      }
    }
  });
});
